/**
 * Control module.
 * @module video/Control
 */

import './style.css';
import tmpl from './main.ejs';
import Events from 'f.core.event';
import Util from 'f.core.util.pc';
const pcVideoUtil = new Util();

/**
 * 格式化时间补零
 * @private
 * @param {*} time
 * @return {string} 格式化后的时间
 */
const formatTime = time => {
    let second = 0;
    let mintue = 0;
    let hour = 0;
    second = Math.floor(time % 60);
    if (time >= 60) {
        mintue = Math.floor(time / 60);
    }
    if (mintue >= 60) {
        mintue = Math.floor(mintue % 60);
        hour = Math.floor(time / 3600);
    }
    hour = hour < 10 ? `0${hour}` : hour;
    second = second < 10 ? `0${second}` : second;
    mintue = mintue < 10 ? `0${mintue}` : mintue;
    return `${hour}:${mintue}:${second}`;
};

/**
 * 控制条
 */
class Control {
    /**
     * Creates an instance of Control.
     * @param {object} obj
     * @param {object} obj.sedata 列表相关数据
     * @memberof Control
     */
    constructor({
        sedata = [],
        videoinfo
    }) {
        this.sedatas = sedata;
        this.videoinfo = videoinfo;
        this.isHide = true;
        this.fullStatus = 'exit'; // 非全屏
        this.playBtnstatus = 'pause';
        this.hideTimer = null;
        this.init();
    }

    /**
     * 初始化
     */
    init() {
        this.initDom();
        this.initCompontent();
        this.initEvent();
    }

    /**
     * 初始化dom
     */
    initDom() {
        /**
         * 组件元素整体
         * @member {HTMLELEMELENT}
         */
        this.el = $(tmpl())[0];
        /**
         * 进度条整体
         * @member {HTMLELEMELENT}
         */
        this.progress = this.el.getElementsByClassName('js_progress_trigger')[0];

        /**
         * 进度条缓存
         * @member {HTMLELEMELENT}
         */
        this.buffered = this.el.getElementsByClassName('js_progress_trigger')[1];

        /**
         * 进度条已进行
         * @member {HTMLELEMELENT}
         */
        this.progressbar = this.el.getElementsByClassName('js_progress_trigger')[2];

        /**
         * 进度条小圆点
         * @member {HTMLELEMELENT}
         */
        this.progresicon = this.el.getElementsByClassName('js_progress_trigger')[3];

        /**
         * 音量整体
         * @member {HTMLELEMELENT}
         */
        this.volume = this.el.getElementsByClassName('js_volume_trigger')[0];

        /**
         * 音量条
         * @member {HTMLELEMELENT}
         */
        this.volumebar = this.el.getElementsByClassName('js_volume_trigger')[1];

        /**
         * 音量小钮
         * @member {HTMLELEMELENT}
         */
        this.volumeicon = this.el.getElementsByClassName('js_volume_trigger')[2];

        /**
         * 音量seek
         * @member {HTMLELEMELENT}
         */
        this.volumeProgress = this.el.getElementsByClassName('volumeProgress')[0];

        /**
         * 音量百分比显示
         * @member {HTMLELEMELENT}
         */
        this.volumeTip = $(this.el).find('#js_volume_tip');

        /**
         * 播放按钮整体
         * @member {HTMLELEMELENT}
         */
        this.videobtn = this.el.getElementsByClassName('js_videobtn_trigger');

        for (let k = 0, klen = this.videobtn.length; k < klen; k++) {
            /**
             * 控制条区域icon
             */
            const _videobtn = this.videobtn[k];

            const _videobtnTag = _videobtn.getAttribute('data-tag');
            switch (_videobtnTag) {
                case 'play':
                    /**
                     * 点击播放按钮
                     */
                    this.jsplay = _videobtn;

                    break;
                case 'pause':
                    /**
                     * 点击暂停按钮
                     */
                    this.jspause = _videobtn;

                    break;
                case 'next':
                    /**
                     * 点击下一条按钮
                     */
                    this.jsnext = _videobtn;

                    break;
                case 'mute':
                    /**
                     * 点击后静音按钮
                     */
                    this.mute = _videobtn;

                    break;
                case 'aloud':
                    /**
                     * 点击后取消静音按钮
                     */
                    this.aloud = _videobtn;

                    break;
                case 'fullscreen':
                    /**
                     * 全屏按钮
                     */
                    this.fullicon = _videobtn;

                    break;
                case 'adaptscreen':
                    /**
                     * 退出全屏按钮
                     */
                    this.adapticon = _videobtn;

                    break;
                case 'rate':
                    /**
                     * 切换码率按钮
                     */
                    this.rateicon = _videobtn;
            }
        }

        /**
         * 已进行时间
         */
        this.playTime = $(this.el).find('#js_video_ptime');

        /**
         * 总时间
         */
        this.totalTime = $(this.el).find('#js_video_ttime');

        /**
         * seek整体
         */
        this.seekTimeAll = $(this.el).find('#js_hover_time');

        /**
         * seek时间
         */
        this.seekTime = $(this.el).find('#js_hover_time span');

        /**
         * 大图预览
         */
        this.bigPreview = $(this.el).find('#js_hover_time div');

        /**
         * 切换码率区域
         */
        this.rate = this.el.getElementsByClassName('js_videorate_trigger');

        /**
         * 悬停时间
         */
        // this.hoverTime = this.el.getElementsByClassName('videoHoverTime');

        /**
         * 滑动音量显示
         */
        this.volumeValue = this.el.getElementsByClassName('volumeTip');

        // console.log($(this.el).find('#js_hover_time span'))
        this.videorate = $(this.el).find('.js_videorate_trigger');

        /**
         * 提示框整体
         */
        this.videoText = $(this.el).find('.videoText');

        /**
         * 提示框关闭按钮
         */
        this.videoTextClose = $(this.el).find('.videoText .js_closetext_trigger');

        /**
         * 提示框文字
         */
        this.videoTextCon = $(this.el).find('#js_video_text');

        /**
         * 码率文字
         */
        this.videoRateTxt = $(this.el).find('#js_video_rateTxt');

        /**
         * 下一条整体
         */
        this.showNext = $(this.el).find('#js_videobtn_showNext');
        // console.log(this.showNext[0])
    }

    /**
     * 初始化组件
     */
    initCompontent() {
        /**
         * 获取下一条视频在播放列表中的位置
         */
        this.videoIndex = this.getInd();

        if (this.videoIndex > -1) {
            const sedata = this.sedatas[this.videoIndex];
            this.sedata = sedata;
            if (typeof sedata != 'undefined') {
                this.setNextDom(sedata);
            }
        }
    }

    /**
     * 初始化自定义事件
     */
    initEvent() {
        this.event = new Events();
        const _this = this;

        /**
         * 鼠标在控制区域时，不隐藏控制条
         */
        pcVideoUtil.bind(_this.el, ['mouseenter', 'mousemove', 'mousedown', 'mouseup', 'click', 'touchstart', 'touchmove'], e => {
            _this.show();
            clearTimeout(_this.hideTimer);
            _this.hideTimer = null;
        });

        /**
         * 鼠标移出控制区域时，设置定时器
         */
        pcVideoUtil.bind(_this.el, ['mouseleave', 'touchend'], e => {
            if (!_this.hideTimer && _this.playBtnstatus == 'play') {
                _this.hideTimer = setTimeout(() => {
                    _this.hide();
                }, 2000);
            }
        });

        /**
         * 播放按钮
         */
        pcVideoUtil.bind(_this.jsplay, 'click', e => {
            // _this.changePlayBtnState('play');
            _this.trigger('cplay');
        });

        /**
         * 暂停按钮
         */
        pcVideoUtil.bind(_this.jspause, 'click', e => {
            // _this.changePlayBtnState('pause');
            _this.trigger('cpause');
        });

        /**
         * 静音
         */
        pcVideoUtil.bind(_this.mute, 'click', e => {
            _this.changeVolume('mute');
            _this.trigger('cmute');
        });

        /**
         * 取消静音
         */
        pcVideoUtil.bind(_this.aloud, 'click', e => {
            _this.changeVolume('aloud');
            _this.trigger('caloud');
        });

        /**
         * 全屏按钮
         */
        pcVideoUtil.bind(_this.fullicon, 'click', e => {
            _this.changeFull('full');
            _this.trigger('full');
        });

        /**
         * 退出全屏按钮
         */
        pcVideoUtil.bind(_this.adapticon, 'click', e => {
            _this.changeFull('exit');
            _this.trigger('exit');
        });

        /**
         * 进度seek
         */
        pcVideoUtil.bind(_this.progress, 'click', e => {
            const percent = _this.getPercent(e.clientX, _this.el);
            _this.trigger('cprogress', percent);
        });

        /**
         * 鼠标移入、滑过视频进度条，显示时间提示
         */
        pcVideoUtil.bind(_this.progress, ['mouseover', 'mousemove'], e => {
            const percent = _this.getPercent(e.clientX, _this.el);
            _this.trigger('cpseekmove', percent);
        });

        /**
         * 鼠标移出视频进度条，隐藏时间提示
         */
        pcVideoUtil.bind(_this.progress, ['mouseout', 'touchend'], e => {
            _this.trigger('cpseekout');
        });

        /**
         * 拖拽进度条
         */
        pcVideoUtil.bind(_this.progresicon, ['mousedown', 'touchstart'], e => {
            // var percent = _this.getPercent(e.clientX);
            // console.log('mousedown')
            _this.trigger('cpdown');

            const myfunction = e => {
                let x = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
                // console.log(e.clientX)
                const percent = _this.getPercent(x, _this.el);
                // console.log('mousemove:' + percent)

                if (e.type === 'touchmove') {
                    _this.trigger('cprogress', percent);
                } else {
                    _this.trigger('cpmove', percent);
                }
            };

            pcVideoUtil.bind(document, ['mousemove', 'touchmove'], myfunction);
            pcVideoUtil.bind(document, ['mouseup', 'touchend'], e => {
                console.log('touchend');
                pcVideoUtil.removeHandler(document, 'mousemove', myfunction);
                pcVideoUtil.removeHandler(document, 'touchmove', myfunction);
            });
        });


        /**
         * 音量条seek
         */
        pcVideoUtil.bind(_this.volumeProgress, 'click', e => {
            const percent = _this.getPercent(e.clientX, _this.volumeProgress);
            _this.trigger('c_v_progress', percent);
        });

        /**
         * 拖拽音量条
         */
        pcVideoUtil.bind(_this.volumeicon, 'mousedown', e => {
            // var percent = _this.getPercent(e.clientX);
            // console.log('mousedown')
            // _this.trigger('cpdown');

            const myfunction = e => {
                // console.log(e.clientX)
                const percent = _this.getPercent(e.clientX, _this.volume);
                // console.log('mousemove:' + percent)
                _this.trigger('cvmove', percent);
            };

            pcVideoUtil.bind(_this.el, 'mousemove', myfunction);
            pcVideoUtil.bind(_this.el, ['mouseup', 'mouseleave'], e => {
                // console.log('mouseup')
                pcVideoUtil.removeHandler(_this.el, 'mousemove', myfunction)
            });
        });


        /**
         * 码率切换鼠标滑过
         */
        pcVideoUtil.bind(_this.rateicon, 'mouseenter', function(e) {
            pcVideoUtil.addClass(this, 'videorateShow');
            e.stopPropagation();
        });

        /**
         * 码率切换鼠标滑出
         */
        pcVideoUtil.bind(_this.rateicon, 'mouseleave', function(e) {
            pcVideoUtil.removeClass(this, 'videorateShow');
            e.stopPropagation();
        });

        /**
         * 码率切换手指抬起
         */
        pcVideoUtil.bind(_this.rateicon, 'touchend', function(e) {
            clearTimeout(_this.rateTimeer);
            pcVideoUtil.addClass(this, 'videorateShow');
            _this.rateTimeer = setTimeout(() => {
                pcVideoUtil.removeClass(this, 'videorateShow');
            }, 2000);
            e.stopPropagation();
        });

        /**
         * 下一条
         */
        $(this.jsnext).on('click', () => {
            if (window.sedata) {
                _this.sedatas = window.sedata;
                _this.initCompontent();
                window.location.href = _this.sedata.link;
            }
        });

        $(this.jsnext).on('mouseenter', () => {
            if (window.sedata) {
                _this.sedatas = window.sedata;
                _this.initCompontent();
            }
        });

        /**
         * 码率切换点击
         */
        this.videorate.on('click', e => {
            let ev = e || window.event;
            const target = ev.target || ev.srcElement;
            if (target.nodeName.toLowerCase() == 'li') {
                if (target.className == 'current') return;
                // console.log(123);
                _this.trigger('changeVideoRate', target);
            }
        });

        /**
         * 提示框关闭
         */
        this.videoTextClose.on('click', () => {
            this.videoTextHide();
        });

        // pcVideoUtil.bind(_this.jsnext, 'mouseenter', function(e) {
        //     _this.trigger('nextEnter');
        //     e.stopPropagation();
        // });
    }

    /**
     * 改变全屏状态样式
     *
     * @param {string} status 全屏状态
     */
    changeFull(status) {
        if (status === 'full') {
            this.fullicon.style.display = 'none';
            this.adapticon.style.display = 'block';
            this.fullStatus = 'full';
        } else {
            this.fullicon.style.display = 'block';
            this.adapticon.style.display = 'none';
            this.fullStatus = 'exit';
        }
    }

    /**
     * 改变播放按钮状态
     *
     * @param {string} status 播放按钮状态
     */
    changePlayBtnState(status) {
        if (status === 'play') {
            this.jsplay.style.display = 'none';
            this.jspause.style.display = 'block';
            this.playBtnstatus = 'play';
        } else {
            this.jsplay.style.display = 'block';
            this.jspause.style.display = 'none';
            this.playBtnstatus = 'pause';
            this.show();
            clearTimeout(this.hideTimer);
            // this.hideTimer = null;
        }
    }

    /**
     * 改变音量样式
     *
     * @param {string} status 音量状态
     */
    changeVolume(status) {
        if (status === 'mute') {
            this.mute.style.display = 'none';
            this.aloud.style.display = 'block';
            this.volumeType = 'mute';
        } else {
            this.mute.style.display = 'block';
            this.aloud.style.display = 'none';
            this.volumeType = 'aloud';
        }
        // pcVideoUtil.playerSetCookie('videoVolume', value, { domain: '.ifeng.com', path: '/', expires: 60 * 24 * 360 });
    }

    /**
     * 设置进行时间
     * @param {string} time 当前时间
     */
    setCurrentTime(time) {
        this.playTime.html(pcVideoUtil.moretime(time));
    }

    /**
     * 设置总时间
     * @param {string} time 总时间
     */
    setTotalTime(time) {
        this.totalTime.html(pcVideoUtil.moretime(time));
    }

    /**
     * 设置悬浮时间
     * @param {string} time 悬浮时间
     */
    setSeekTime(time) {
        this.seekTime.html(pcVideoUtil.moretime(time));
    }

    /**
     * 显示缩略图
     *
     * @param {number} time
     * @param {number} msg
     * @memberof Control
     */
    showImgPreview(time, msg) {
        /**
         * 第几个小图
         */
        const number = Math.ceil(time / msg.time_span);

        /**
         * 一行几个
         */
        const linenumber = msg.width / msg.sub_width;

        /**
         * 一列几个
         */
        const columnnumber = msg.height / msg.sub_height;

        /**
         * 一页有几个小图
         */
        const pagenumber = linenumber * columnnumber;

        /**
         * 小图所在页数
         */
        const page = Math.ceil(number / pagenumber) - 1;

        /**
         * 小图所在行数
         */
        const line = Math.ceil((number - page * pagenumber) / linenumber) - 1;

        /**
         * 小图所在列数
         */
        const column = number - page * pagenumber - line * linenumber - 1;

        const img = msg.path.split(',');

        this.bigPreview.css({
            'width': msg.sub_width,
            'height': msg.sub_height,
            'background': `url(${img[page]}) -${column * msg.sub_width}px -${line * msg.sub_height}px`
        });
    }

    /**
     * 悬浮时间显示
     */
    seekTimeShow() {
        this.seekTimeAll.addClass('videoHoverTimeShow');
    }

    /**
     * 悬浮时间隐藏
     */
    seekTimeHide() {
        /**
         * 显示进度条时间提示videoHoverTime+videoHoverTimeShow
         */
        setTimeout(() => {
            this.seekTimeAll.removeClass('videoHoverTimeShow');
        }, 1000);
    }

    /**
     * 悬浮音量显示
     */
    volumeTipShow() {
        clearTimeout(this.NewVolumeValueTimer);
        this.NewVolumeValueTimer = null;
        this.volumeTip.addClass('volumeValueShow');
        if (this.NewVolumeValueTimer == null) {
            this.NewVolumeValueTimer = setTimeout(() => {
                this.volumeTip.removeClass('volumeValueShow');
            }, 1000);
        }
    }

    /**
     * 获取占控制条的百分比
     *
     * @param {number} end 最后的位置
     * @param {HTMLELEMENT} ele 控制条元素
     * @return {number} 占控制条的百分比
     */
    getPercent(end, ele) {
        const r = ele.getBoundingClientRect();
        const left = r.left;
        const width = r.width;
        const percent = (end - left) / width;
        return percent < 0 ? 0 : percent > 1 ? 1 : percent;
    }

    /**
     * 设置已经行进度条
     *
     * @param {number} percent
     */
    setCurrentProgress(percent) {
        if (percent < 0.01) percent = 0.01;
        const pp = percent * 100 > 99 ? 99 : percent * 100;
        this.progressbar.style.width = `${pp}%`;
    }

    /**
     * 设置已经行音量条
     *
     * @param {number} percent
     */
    setCurrentVolume(percent) {
        this.volumebar.style.width = `${percent * 100}%`;
    }

    /**
     * 设置音量百分比提示
     *
     * @param {number} percent
     */
    setVolumeWarn(percent) {
        const num = Math.round(percent * 100);
        this.volumeTip.html(`${num}%`);
    }

    /**
     * 设置缓存进度条
     *
     * @param {number} percent
     */
    setBufferProgress(percent) {
        this.buffered.style.width = `${percent * 100}%`;
    }

    /**
     * 设置seek进度条
     * @param {number} percent
     */
    setSeekProgress(percent) {
        this.seekTimeAll.css('left', `${percent * 100}%`);
    }


    /**
     * 设置提示框文字内容
     * @param {string} html
     */
    setVideoTextCon(html) {
        // body...
        this.videoTextCon.html(html);
    }

    /**
     * 设置码率文字
     * @param {string} html
     */
    setVideoRateTxt(html) {
        // body...
        this.videoRateTxt.html(html);
    }

    /**
     * 提示框整体显示
     */
    videoTextShow() {
        this.videoText.addClass('videoTextShow');
    }

    /**
     * 提示框整体隐藏
     */
    videoTextHide() {
        this.videoText.removeClass('videoTextShow');
    }

    /**
     * 启动全屏
     *
     * @param {HTMLELEMENT} ele
     */
    launchFullscreen(ele) {
        // if (this.fullStatus == 'full') return;
        if (ele.requestFullscreen) {
            ele.requestFullscreen();
        } else if (ele.mozRequestFullScreen) {
            ele.mozRequestFullScreen();
        } else if (ele.msRequestFullscreen) {
            ele.msRequestFullscreen();
        } else if (ele.oRequestFullscreen) {
            ele.oRequestFullscreen();
        } else if (ele.webkitRequestFullscreen) {
            ele.webkitRequestFullScreen();
        }
    }

    /**
     * 退出全屏
     *
     * @param {HTMLELEMENT} ele
     */
    exitFullscreen(ele) {
        // if (this.fullStatus == 'exit') return;
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.oRequestFullscreen) {
            document.oCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }

    /**
     * 获取下一条列表序号
     *
     * @return {number} 下一条列表序号
     */
    getInd() {
        // var a = '01f9ed9e-c569-40ac-9875-75bea17f330b';
        this.sedatas = window.sedata || this.sedatas;
        let value = -1;
        if (this.videoinfo && typeof this.sedatas !== 'undefined') {
            const guid = this.videoinfo.vid;
            const len = this.sedatas.length;
            this.sedatas.forEach((b, c) => {
                if (b.id == guid) {
                    value = c + 1 == len ? -1 : c + 1;
                }
            });
        }
        return value;
    }

    /**
     * 设置下一条视频的dom内容
     *
     * @param {object} _sedata 下一条视频内容
     */
    setNextDom(_sedata) {
        pcVideoUtil.addClass(this.jsnext, 'haveNext');
        // console.log(this.showNext.find('#js_videonext_img'))
        this.showNext.find('#js_videonext_img').html(`<img src="${_sedata.img}" width="100%" height="100%" />`)
        this.showNext.find('#js_videonext_time').html(pcVideoUtil.formatTime(_sedata.duration));
        this.showNext.find('#js_videonext_abstract').html(_sedata.text);

        // document.getElementById('js_videonext_time').innerHTML = pcVideoUtil.formatTime(_sedata.duration);
        // document.getElementById('js_videonext_abstract').innerHTML = _sedata.text;
    }

    setTime(val, willTrigger) {
        if (val < 0) {
            val = 0;
        } else if (val > 1) {
            val = 1;
        }

        this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
        this.elTimeHandle.style.marginLeft = `${this.timeBarWidth * val}px`;
        this.elTimeBarProgress.style.width = `${val * 100}%`;
        this.timeValue = val;

        if (willTrigger) {
            this.trigger('time', val);
        }
    }

    setTimeVal(timeString) {
        this.elTimeVal.innerHTML = `- ${formatTime(timeString)}`;
    }

    renderTo(parentNode) {
        parentNode.appendChild(this.el);
        // this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
        // this.setTime(0, true);
    }

    show() {
        // $(this.el).stop().animate({
        //   bottom: '0px'
        // });
        pcVideoUtil.removeClass(this.el, 'videoControlHalfHide');
        // if (_this.fullFlag && !_this.rightFlag) pcVideoUtil.addClass(topdom, 'videosiderTopShow');
        this.trigger('show');
        this.isHide = false;
        // clearTimeout(this.hideTimer);
        // this.hideTimer = setTimeout(function() {
        //     this.hide();
        // }.bind(this), 3000);
    }

    hide() {
        // $(this.el).stop().animate({
        //   bottom: '-100px'
        // });
        if (this.isHide) return;
        pcVideoUtil.addClass(this.el, 'videoControlHalfHide');
        // if (_this.fullFlag) pcVideoUtil.removeClass(topdom, 'videosiderTopShow');


        // this.el.style.visibility = 'hidden';
        this.isHide = true;
        this.trigger('hide');
    }

    hideAll() {
        $(this.el).addClass('videoControlHide');
    }

    showAll() {
        $(this.el).removeClass('videoControlHide');
    }

    toggle() {
        if (this.isHide == true) {
            this.show();
        } else {
            this.hide();
        }
    }

    resize() {
        this.timeBarWidth = this.elTimeBar.offsetWidth - this.elTimeHandle.offsetWidth;
        this.setTime(this.timeValue);
    }

    /**
     *
     * 销毁组件
     */
    destory() {
        this.off();
        this.el.removeEventListener('click', clickFn);
        this.el.parentNode.removeChild(this.el);
    }
}

Events.mixTo(Control);

export default Control;


// WEBPACK FOOTER //
// ./components/f.component.video.pc/app/modules/recodeControl/index.js